import React from "react";
import { Link } from "react-router-dom";
import { toAbsoluteUrl } from "../../_metronic/_helpers";

export function PrivacyPolicyPage() {
  return (
    <div className="d-flex flex-column flex-root bg-light min-vh-100 py-10 px-5 px-md-10">
      <div className="container max-w-800px mx-auto">
        {/* Header / Logo section */}
        <div className="d-flex justify-content-between align-items-center mb-8 pb-5 border-bottom">
          <Link to="/" className="d-flex align-items-center">
            <img
              alt="Link For All Logo"
              className="max-h-50px"
              src={toAbsoluteUrl("/media/logos/my-link-for-all-logo.png")}
            />
          </Link>
          <Link to="/auth/login" className="btn btn-outline-primary font-weight-bold btn-sm">
            Back to Application
          </Link>
        </div>

        {/* Card Content */}
        <div className="card card-custom shadow-sm border-0 mb-10">
          <div className="card-body p-8 p-md-12">
            <h1 className="font-weight-bolder text-dark mb-4 display-5">
              Privacy Policy
            </h1>
            <p className="text-muted font-size-lg mb-8">
              Your privacy is very important to us. This Privacy Policy describes how Link For All (&quot;we&quot;, &quot;us&quot;, or &quot;our&quot;) collects, uses, and protects your information when you use our web application (the &quot;Service&quot;).
            </p>

            <hr className="my-8" />

            <div className="mb-8">
              <h3 className="font-weight-bold text-dark mb-4">
                1. Information We Collect
              </h3>
              <p className="text-dark-75 font-size-md mb-3">
                <strong>Account Information:</strong> When you sign up for a user account through Google or Apple authentication, we collect your display name, email address, and profile photo URL. This information is used solely to manage your account and subscriptions.
              </p>
              <p className="text-dark-75 font-size-md mb-0">
                <strong>Device and Technical Data:</strong> We may collect anonymized browser type, OS version, and page load statistics to improve the technical performance of our Service.
              </p>
            </div>

            <div className="mb-8">
              <h3 className="font-weight-bold text-dark mb-4">
                3. Subscriptions &amp; Payment Processing
              </h3>
              <p className="text-dark-75 font-size-md mb-0">
                We partner with secure, PCI-compliant third-party payment gateways (such as Stripe, Shopify, the Apple App Store, and the Google Play Store) to handle recurring subscription payments. We do not collect, process, or store your credit card details or bank account numbers on our servers. All billing information is entered directly into our payment partner systems, which are governed by their respective privacy policies.
              </p>
            </div>

            <div className="mb-8">
              <h3 className="font-weight-bold text-dark mb-4">
                4. How We Use Your Information
              </h3>
              <p className="text-dark-75 font-size-md mb-3">
                We use account and subscription data to:
              </p>
              <ul className="text-dark-75 font-size-md pl-6">
                <li className="mb-2">Verify you and allow template saving/sharing.</li>
                <li className="mb-2">Provide technical support and respond to customer queries.</li>
                <li className="mb-2">Enforce community guidelines and prevent fraudulent account activity.</li>
              </ul>
            </div>

            <div className="mb-8">
              <h3 className="font-weight-bold text-dark mb-4">
                5. Data Retention &amp; Deletion
              </h3>
              <p className="text-dark-75 font-size-md mb-0">
                We retain your account data for as long as your account is active. You can request deletion of your account and associated profile information at any time by contacting our support team.
              </p>
            </div>

            <div className="mb-4">
              <h3 className="font-weight-bold text-dark mb-4">
                6. Contact Us
              </h3>
              <p className="text-dark-75 font-size-md mb-3">
                If you have any questions or concerns about this Privacy Policy or how we handle your data, please contact us at:
              </p>
              <div className="bg-light p-5 rounded border border-secondary opacity-80">
                <div className="font-weight-bolder text-dark font-size-lg mb-1">
                  Link For All Ltd.
                </div>
                <div className="text-muted font-size-md">
                  3 Brook Lane, Loughborough, LE11 3 RA, United Kingdom
                </div>
              </div>
            </div>
          </div>
          <div className="card-footer bg-light-o-50 border-0 py-4 px-8 d-flex justify-content-between align-items-center">
            <span className="text-muted font-size-sm">
              &copy; {new Date().getFullYear()} Link For All Ltd. All rights reserved. | Developed by{" "}
              <a
                href="https://whizpool.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary font-weight-bold"
              >
                Whizpool
              </a>
            </span>
            <Link to="/auth/login" className="text-primary font-weight-bold font-size-sm">
              Return to Sign In
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicyPage;
